import React from "react";
import { Link } from "react-router-dom";
import aboutImg from "../assets/images/project.png"

import {FiCheckCircle, MdKeyboardArrowRight} from '../assets/icons/vander'

export default function AboutOne(){
    return(
        <>
        <div className="container relative md:mt-24 mt-16">
            <div className="grid md:grid-cols-2 grid-cols-1 items-center gap-6">
                <div className="relative overflow-hidden rounded-lg border border-amber-400/5 bg-gradient-to-tl to-amber-400/30  from-fuchsia-600/30 dark:to-amber-400/50 dark:from-fuchsia-600/50 ps-6 pt-6 lg:me-8">
                    <img src={aboutImg} className="ltr:rounded-tl-lg rtl:rounded-tr-lg" alt=""/>
                </div>

                <div className="">
                    <h3 className="mb-4 md:text-3xl md:leading-normal text-2xl leading-normal font-semibold">Por que Escolher a Hope Creative?</h3>
                    <p className="text-slate-400 max-w-xl">Na Hope Creative, acreditamos que a tecnologia é a chave para desbloquear o verdadeiro potencial de sua empresa. Aqui estão algumas razões pelas quais somos a escolha certa para suas necessidades de desenvolvimento de software sob medida:</p>

                    <ul className="list-none text-slate-400 mt-4">
                        <li className="mb-2 flex items-center"><FiCheckCircle className="text-amber-400 h-5 w-5 me-2"/>Expertise e Experiência
                        </li>
                        <li className="mb-2 flex items-center"><FiCheckCircle className="text-amber-400 h-5 w-5 me-2"/>Soluções
                            Personalizadas
                        </li>
                        <li className="mb-2 flex items-center"><FiCheckCircle className="text-amber-400 h-5 w-5 me-2"/>Foco
                            na Qualidade
                        </li>
                        <li className="mb-2 flex items-center"><FiCheckCircle className="text-amber-400 h-5 w-5 me-2"/>Inovação
                            Contínua
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        </>
    )
}